module.exports = __webpack_public_path__ + "img/171-Siena PL.jpg";